// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    padding: 0;
    /* overflow-y: hidden !important; */
}

.Authorization-module__authBoxFon--NTmWh {
    /* padding: 20px; */
    position: absolute;
    right: 0;
    top: 0;
}

.Authorization-module__authBoxContainer--fSroc {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 97vh;
    flex-direction: column;
}

.Authorization-module__contentForm--x3sPc {
    position: relative;
    left: 0;
    width: 50%;
}

.Authorization-module__authBox--OXVKs {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;
    padding: 30px;
    border-radius: 14px;
    -webkit-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
    -moz-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
    box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
}

.Authorization-module__logo--nP5m_ {
    /* position: absolute;
    top: 100px; */
    margin-bottom: 50px;
}


.Authorization-module__formBox--uoN1K {
    display: flex;
    flex-direction: column;
    margin-bottom: 25px;
    align-content: center;
    align-items: center;
    justify-content: center;
}

.Authorization-module__titleBox--StWcp>h1 {
    font-size: 23px;
    color: #8F9BB3;
    font-weight: 400;
    text-decoration: none;
    font-style: normal;
    font-variant: normal;
    text-transform: none;
}

.Authorization-module__titleBox--StWcp {
    margin-bottom: 25px;
}

.Authorization-module__emailInput--QoaGq {
    width: 350px;
    margin-bottom: 30px !important;
}

.Authorization-module__codeBtn--E70zZ {
    width: 350px;
}

.Authorization-module__logoContainer--CamgL {
    position: absolute;
    width: 250px;
    z-index: 1000;
}

.Authorization-module__logoContainer--CamgL img {
    width: 100%;
    height: auto;
}

.Authorization-module__textBox--jOZSc {
    width: 250px;
    text-align: center;
    margin: 0 auto;
    font-size: 14px;
}
.Authorization-module__redText--IOdJ8 {
    color: #BD0048;
}
.Authorization-module__dopBtn--OmX8D {
    margin-top: 40px;
    color: white;
}
.Authorization-module__dopBtn--OmX8D > p > a {
    color: white;
}


.Authorization-module__unboundedTitle--bDGpo {
    font-family: 'Unbounded', sans-serif;
}

@media (max-width: 1130px) {
    .Authorization-module__contentForm--x3sPc {
        width: 100%;
    }
    .Authorization-module__authBoxFon--NTmWh {
        display: none;
    }

}`, "",{"version":3,"sources":["webpack://./src/pages/auth/Authorization.module.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,4DAA4D;IAC5D,yDAAyD;IACzD,oDAAoD;AACxD;;AAEA;IACI;iBACa;IACb,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,YAAY;AAChB;;;AAGA;IACI,oCAAoC;AACxC;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,aAAa;IACjB;;AAEJ","sourcesContent":["body {\r\n    margin: 0;\r\n    padding: 0;\r\n    /* overflow-y: hidden !important; */\r\n}\r\n\r\n.authBoxFon {\r\n    /* padding: 20px; */\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0;\r\n}\r\n\r\n.authBoxContainer {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 97vh;\r\n    flex-direction: column;\r\n}\r\n\r\n.contentForm {\r\n    position: relative;\r\n    left: 0;\r\n    width: 50%;\r\n}\r\n\r\n.authBox {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: white;\r\n    padding: 30px;\r\n    border-radius: 14px;\r\n    -webkit-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n    -moz-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n    box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n}\r\n\r\n.logo {\r\n    /* position: absolute;\r\n    top: 100px; */\r\n    margin-bottom: 50px;\r\n}\r\n\r\n\r\n.formBox {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-bottom: 25px;\r\n    align-content: center;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.titleBox>h1 {\r\n    font-size: 23px;\r\n    color: #8F9BB3;\r\n    font-weight: 400;\r\n    text-decoration: none;\r\n    font-style: normal;\r\n    font-variant: normal;\r\n    text-transform: none;\r\n}\r\n\r\n.titleBox {\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.emailInput {\r\n    width: 350px;\r\n    margin-bottom: 30px !important;\r\n}\r\n\r\n.codeBtn {\r\n    width: 350px;\r\n}\r\n\r\n.logoContainer {\r\n    position: absolute;\r\n    width: 250px;\r\n    z-index: 1000;\r\n}\r\n\r\n.logoContainer img {\r\n    width: 100%;\r\n    height: auto;\r\n}\r\n\r\n.textBox {\r\n    width: 250px;\r\n    text-align: center;\r\n    margin: 0 auto;\r\n    font-size: 14px;\r\n}\r\n.redText {\r\n    color: #BD0048;\r\n}\r\n.dopBtn {\r\n    margin-top: 40px;\r\n    color: white;\r\n}\r\n.dopBtn > p > a {\r\n    color: white;\r\n}\r\n\r\n\r\n.unboundedTitle {\r\n    font-family: 'Unbounded', sans-serif;\r\n}\r\n\r\n@media (max-width: 1130px) {\r\n    .contentForm {\r\n        width: 100%;\r\n    }\r\n    .authBoxFon {\r\n        display: none;\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"authBoxFon": `Authorization-module__authBoxFon--NTmWh`,
	"authBoxContainer": `Authorization-module__authBoxContainer--fSroc`,
	"contentForm": `Authorization-module__contentForm--x3sPc`,
	"authBox": `Authorization-module__authBox--OXVKs`,
	"logo": `Authorization-module__logo--nP5m_`,
	"formBox": `Authorization-module__formBox--uoN1K`,
	"titleBox": `Authorization-module__titleBox--StWcp`,
	"emailInput": `Authorization-module__emailInput--QoaGq`,
	"codeBtn": `Authorization-module__codeBtn--E70zZ`,
	"logoContainer": `Authorization-module__logoContainer--CamgL`,
	"textBox": `Authorization-module__textBox--jOZSc`,
	"redText": `Authorization-module__redText--IOdJ8`,
	"dopBtn": `Authorization-module__dopBtn--OmX8D`,
	"unboundedTitle": `Authorization-module__unboundedTitle--bDGpo`
};
export default ___CSS_LOADER_EXPORT___;
